// ======================================================================
// File Name       : multiLanguage
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function postLanguageInfo(data) {
  return commonCallApi({
    path: 'document/LanguageInfo',
    data: { ...data },
  });
}

export function postMultiLanguageGetList(data) {
  return commonCallApi({
    path: 'document/GetMultiLanguageDocumentList',
    data: { ...data },
  });
}

export function postTranslate(data) {
  return commonCallApi({
    path: 'document/Translate',
    data: { ...data },
  });
}

export function postMultiLanguageEdit(data) {
  return commonCallApi({
    path: 'document/MultiLanguageEdit',
    data: { ...data },
    muiltipart: 1,
  });
}

export function postGetMultiLanguageProcessResultList(data) {
  return commonCallApi({
    path: 'document/GetMultiLanguageProcessResultList',
    data: { ...data },
  });
}

export function postGetMultiLanguageProcessDetail(data) {
  return commonCallApi({
    path: 'document/GetMultiLanguageProcessDetail',
    data: { ...data },
  });
}
